import * as formWizardConstants from './constants';

/**
 * Gets the active panel in the form
 *
 * @param {Element} form
 */
export default function getActivePanel(form) {
  if (!form) return;
  return form.querySelector(formWizardConstants.selectors.activePanel);
}
